import { backgroundColor, primaryColor } from "@/utils/theme";
import {
	createPart,
	ModuleRegistry,
	provideGlobalGridOptions,
	themeMaterial,
} from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;

LicenseManager.setLicenseKey(licenseKey);

const customPart = createPart({
	feature: "mesfGrid",
	css: `
    .ag-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-header-cell {
      padding: 0px !important;
      text-align: center !important;
      font-size: 0.625rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-header-group-cell-label {
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-theme-material .ag-row:hover, & .ag-theme-material .ag-row.custom-selected {
      backgroundColor: ${backgroundColor},
    }

    .ag-checkbox-input-wrapper.ag-checked {
      background-color: ${primaryColor} !important;
      border-color: ${primaryColor} !important;
    }

    .ag-checkbox-input-wrapper.ag-checked::after {
      color: white;
    }

    .ag-header-select-all {
      margin-left: 28px;
    }

    .ag-row-hover .buttons  {
      opacity: 1
    }
    .ag-row-focus .buttons  {
      opacity: 1
    }
    .ag-row-selected .buttons {
      opacity: 1
    }`,
});

export const themeDXT = themeMaterial.withPart(customPart);

ModuleRegistry.registerModules([AllEnterpriseModule]);
provideGlobalGridOptions({
	theme: themeDXT,
});
